import { apiPageBuilderHistory, PageBuilderTemplateItemProps } from ".";
import { apiPageFindById } from "apis/page/find";
import { loading, init, PageBuilderState } from "store/page-builder";
import { apiLayoutFindById } from "apis/layout";
import { store } from "store";
import { uuid } from "utils";

interface ApiPageBuilderInitInputProps {
    pageId: number;
}

type ApiPageBuilderInitOutputProps = boolean;

export const apiPageBuilderInit = async (data: ApiPageBuilderInitInputProps): Promise<ApiPageBuilderInitOutputProps> => {
    store.dispatch(loading());
    let result: boolean = true;
    let dataInit: PageBuilderState = { uid: uuid(), loading: false, history: [], builder: {} }
    const pageRes = await apiPageFindById({ id: data.pageId });
    if (pageRes.status) {
        dataInit.page = pageRes.data.item;
        const builderRes = await apiPageBuilderHistory({ pageId: data.pageId, page: 1, pageSize: 10 });
        if (builderRes.status) {
            const builderActive = builderRes.data.active;
            if (builderActive?.layoutId) {
                const layoutRes = await apiLayoutFindById({ id: builderActive.layoutId });
                if (layoutRes.status) {
                    dataInit.builder = {
                        ...dataInit.builder,
                        layout: {
                            ...layoutRes.data.item,
                            content: convertContent(layoutRes.data.item.content, builderActive.templates)
                        },
                        templates: builderActive.templates
                    };
                }
                else {
                    result = false;
                }
            }
            dataInit.history = builderRes.data.list;
            dataInit._pagination = builderRes.data.pagination;
        }
        else {
            result = false;
        }
    }
    else {
        result = false;
    }
    store.dispatch(init(dataInit));
    return result;
};

function convertContent(content: string, templates: PageBuilderTemplateItemProps[] = []) {
    // parse content thành DOM
    const parser = new DOMParser();
    const doc = parser.parseFromString(content, "text/html");

    // lấy tất cả thẻ render
    const renders = doc.querySelectorAll("render[data-id]");

    renders.forEach(renderEl => {
        const uid = renderEl.getAttribute("data-id");

        // tìm các template có cùng uid
        const matched = templates.filter(t => t.uid === uid) as PageBuilderTemplateItemProps[];

        // xoá nội dung cũ
        renderEl.innerHTML = "";

        // thêm template con
        matched
            .sort((a, b) => a.index - b.index) // sắp xếp tăng dần theo index
            .forEach(t => {
                const tpl = doc.createElement("template");
                tpl.setAttribute("data-id", t.templateId.toString());
                tpl.setAttribute("data-index", t.index.toString());
                renderEl.appendChild(tpl);
            });
    });

    // trả lại content
    return doc.body.innerHTML;
}